import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'common-price-details',
  imports: [],
  templateUrl: './price-details.component.html',
  styleUrl: './price-details.component.scss',
})
export class PriceDetailsComponent {
  @Input() sellingRate: string;
  @Input() buyingRate: string;
  @Input() profit: string;

  constructor(private readonly activeModal: NgbActiveModal) {}

  public closeModal(): void {
    this.activeModal.dismiss();
  }
}
